import { render, staticRenderFns } from "./LargeDirectRecordSign.vue?vue&type=template&id=41070af3&scoped=true"
import script from "./LargeDirectRecordSign.vue?vue&type=script&lang=ts"
export * from "./LargeDirectRecordSign.vue?vue&type=script&lang=ts"
import style0 from "./LargeDirectRecordSign.vue?vue&type=style&index=0&id=41070af3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41070af3",
  null
  
)

export default component.exports